import type { Paragraph } from '@/api/types/stowed-element'
import {
  DEFAULT_ALIGNMENT,
  DEFAULT_FONT_FAMILY_ID,
  DEFAULT_FONT_ID,
  DEFAULT_POINT_SIZE,
} from '@/lib/text/constants/text-defaults'

export function blankParagraphFromExisting(existing?: Paragraph): Paragraph {
  const existingRun = existing?.textLines?.[0]?.textRuns?.[0]

  return {
    ...(existing
      ? {
          alignment: existing.alignment,
          spaceBefore: existing.spaceBefore,
          spaceAfter: existing.spaceAfter,
          indentation: existing.indentation,
          style: existing.style,
          dropCap: existing.dropCap,
          dropCapLines: existing.dropCapLines,
          dropCapOffset: existing.dropCapOffset,
        }
      : { alignment: DEFAULT_ALIGNMENT }),
    textLines: [
      {
        textRuns: [
          {
            ...(existingRun
              ? {
                  fontId: existingRun.fontId,
                  fontFamilyId: existingRun.fontFamilyId,
                  pointSize: existingRun.pointSize,
                  underline: existingRun.underline,
                  strikethrough: existingRun.strikethrough,
                  kerning: existingRun.kerning,
                  tracking: existingRun.tracking,
                  leading: existingRun.leading,
                  lineStyle: existingRun.lineStyle,
                  fillStyle: existingRun.fillStyle,
                  verticalAlign: existingRun.verticalAlign,
                }
              : {
                  pointSize: DEFAULT_POINT_SIZE,
                  fontId: DEFAULT_FONT_ID,
                  fontFamilyId: DEFAULT_FONT_FAMILY_ID,
                }),
            textContent: '',
          },
        ],
      },
    ],
  }
}
